<template>
  <div
    class="dashboard-sidebar-container">
    <div class="d-flex flex-column flex-md-row">
      <!-- Title -->
      <div v-if="showToolbar === false">
        <button
          class="btn btn-sm bg-orange-btn text-white d-flex align-items-center py-0 px-2 rounded-0 rounded-bottom fw-light"
          @click="onClick()">
          Show Data Explorer
          <i class="uil uil-angle-double-down fs-20"></i>
        </button>
      </div>
      <div class="d-flex flex-column">
        <div v-if="showToolbar === false" class="d-flex flex-row">
          <span v-if="toolbarType === 'detail'" v-html="title.scenario1_detail_obj.title" class="fw-light title-text px-2"></span>
        </div>
      </div>
      <!-- /Title -->
    </div>
    <div id="detail-toolbar" v-if="toolbarType === 'detail' && topbarFilterInputs.scenario1">
      <!-- Toolbar Phase3 -->
      <div v-if="showToolbar === true" class="h-100 w-100 m-0">
        <!-- <div class="d-flex flex-row justify-content-between align-items-center">
          <div>
            <button
              class="btn btn-sm bg-orange-btn text-white d-flex align-items-center py-0 px-2 rounded-0 rounded-bottom fw-light"
              @click="onClick()">
              Hide Data Explorer
              <i class="uil uil-angle-double-up fs-20"></i>
            </button>
          </div>
        </div> -->
        <div class="toolbar-table-container d-flex flex-column flex-lg-row">
          <div class="country-selection-container d-flex flex-row flex-lg-column border border-light-blue-grey1 border-1 border-top-0 border-start-0 border-bottom-0">
            <div class="d-flex flex-row">
              <filter-panel
                :space="4"
                :selected-object="topbarFilterInputs.scenario1.selectedObject"
                :mode-status="topbarFilterInputs.scenario1.modeStatus"
                :filters="topbarFilterInputs.scenario1.countryFilters"
                @selectedChanged="setSidebarSelection()">
              </filter-panel>
              <filter-panel
                :space="4"
                :selected-object="topbarFilterInputs.scenario1.selectedObject"
                :mode-status="topbarFilterInputs.scenario1.modeStatus"
                :filters="topbarFilterInputs.scenario1.outcomeFilters"
                @selectedChanged="setSidebarSelection()">
              </filter-panel>
            </div>
          </div>
          <sp-2-lnob-toolbar-table
            :selected-object-a="topbarFilterInputs.scenario1.selectedObject"
            :mode-status-a="topbarFilterInputs.scenario1.modeStatus"
            :filters-a="topbarFilterInputs.scenario1.filters"
            :mode="mode"
            @selectedChanged="setSidebarSelection()">
          </sp-2-lnob-toolbar-table>
        </div>
        <div class="d-flex flex-row variable-des">
          <strong>Variable description</strong>: {{ outcomeVariableDescription }}.
        </div>
      </div>
      <!-- /Toolbar Phase3 -->
    </div>
  </div>
</template>

<script>
import FilterPanel from '@/components/FilterPanel.vue';
import Sp2LnobToolbarTable from '@/components/Sp2LnobToolbarTable.vue';
import { RAPI_DOMAIN, RAPI_VERSION_URL } from '@/environment';
import _ from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import { topbarFilterInputs } from '../data';
import { getTextFromTemplate } from '../helper';
import { initPopover } from '../libs/popover';

export default {
  props: {
    mode: { type: String, default: 'comparative' },
    inputParams: { type: Object, default: undefined }
  },
  components: {
    FilterPanel,
    Sp2LnobToolbarTable
  },
  computed: {
    ...mapGetters('analysis', [
      'getIndicators',
      'getCountries',
      'getSp2lnobCountries',
      'getValueTypes',
      'getLabels',
      'getSchemes',
      'getBenefitLevels',
      'getPovertyMeanTesteds',
      'getSp2lnobConfigs',
      'getDashboardToolbarType',
      'getShowToolbar',
      'getGlossaries'
    ]),
    ...mapGetters('user', [
      'getuserData'
    ]),
    ...mapState('analysis', [
      'compareConfigs',
      'indicators',
      'parameters',
      'dashboardToolbarType',
      'showToolbar'
    ])
  },
  data: function () {
    return {
      loopBackApiPath: `${RAPI_DOMAIN}${RAPI_VERSION_URL}`,
      topbarFilterInputs: {},
      toolbarType: 'normal', // normal , detail
      showToolbar: true,
      title: {
        scenario1: '',
        scenario1_detail_obj: {}
      },
      outcomeVariables: [],
      outcomeVariablesByCountries: {},
      outcomeVariableDescription: ''
    };
  },
  mounted: function () {
    this.initialize();
  },
  watch: {
    dashboardToolbarType: function () {
      // console.log(this.dashboardToolbarType);
      this.toolbarType = _.cloneDeep(this.getDashboardToolbarType);
      this.maintainSelection();
    },
    showToolbar: function () {
      this.showToolbar = _.cloneDeep(this.getShowToolbar);
    }
  },
  methods: {
    ...mapActions('analysis', [
      'fetchCountries',
      'fetchSp2lnobCountries',
      'fetchSchemes',
      'fetchBenefitLevels',
      'fetchPovertyMeanTesteds',
      'updateSp2lnobConfigs',
      'updateDashboardToolbarType',
      'updateShowToolbar',
      'updateCountries',
      'getBenefitCurrencyData',
      'getBenefitCurrencySetData',
      'getCountryById',
      'getSp2lnobIndicatorsByCountry'
    ]),
    ...mapActions('user', [
      'fetchUserData'
    ]),
    initialize: function () {
      this.topbarFilterInputs = _.cloneDeep(topbarFilterInputs);
      this.showToolbar = this.getShowToolbar;
      this.fetchListData();
      this.updateToolbarText();
    },
    onClick () {
      this.showToolbar = !this.showToolbar;
      this.updateShowToolbar(this.showToolbar);
      setTimeout(() => {
        initPopover();
      }, 270); // Wait for HTML rendering
    },
    async fetchListData () {
      await this.fetchUserData();
      await this.fetchCountries();
      await this.fetchSp2lnobCountries();
      await this.fetchSchemes();
      await this.fetchBenefitLevels();
      await this.fetchPovertyMeanTesteds();
      this.setFirsLoadSelection();
      this.setListDataByPermission();
      this.setDropdownItemFromTaxonomies();
      this.setSidebarSelection();
    },
    setListDataByPermission () {
      const userData = _.cloneDeep(this.getuserData);
      if (!userData) {
        const countryList = _.cloneDeep(this.getCountries);
        const filteredCountries = _.filter(countryList, (d) => { return d.field_is_public === 'True'; });
        this.updateCountries({ data: filteredCountries });
      }
    },
    setFirsLoadSelection () {
      const inputParams = _.cloneDeep(this.inputParams);
      let inputShowToolbar;
      // console.log(inputParams);
      if (this.inputParams && Object.keys(this.inputParams).length) {
        this.mode = inputParams.mode ? inputParams.mode : this.mode;
        // this.topbarFilterInputs.scenario1.selectedObject = inputParams.detailScenario1 ? inputParams.detailScenario1 : this.topbarFilterInputs.scenario1.selectedObject;
        // console.log(this.topbarFilterInputs.scenario1.countryFilters[0].items.map(cf => cf.value));
        if (inputParams.country && this.topbarFilterInputs.scenario1.countryFilters[0].items.map(cf => cf.value).includes(inputParams.country)) {
          this.topbarFilterInputs.scenario1.selectedObject.country = inputParams.country;
        }
        if (inputParams.outcome_variable) {
          this.topbarFilterInputs.scenario1.selectedObject.outcome_variable = inputParams.outcome_variable;
        }
        inputShowToolbar = inputParams.showToolbar !== undefined ? inputParams.showToolbar : undefined;
        // this.verifyAvailableFilter();
        // this.topbarFilterInputs.scenario1.selectedObject.country =
      } else {
        // set firstload country
        // if (countryList.length) {
        //   const firstLoadCountry = _.orderBy(countryList, 'name')[0];
        //   this.filterPanelInputs.scenario1.selectedObject.country = firstLoadCountry.tid;
        //   this.topbarFilterInputs.scenario1.selectedObject.country = firstLoadCountry.tid;
        // }
      }

      if (inputShowToolbar !== undefined) {
        this.showToolbar = inputShowToolbar;
        this.updateShowToolbar(inputShowToolbar);
      }

      this.updateBenefitFirstLoad();
    },
    verifyAvailableFilter () {
      // Verify available filter
      const countryList = _.cloneDeep(this.getCountries);
      const firstLoadCountry = _.orderBy(countryList, 'name')[0];

      this.topbarFilterInputs.scenario1.selectedObject.country = _.find(countryList, (d) => { return d.tid === this.topbarFilterInputs.scenario1.selectedObject.country; }) ? this.topbarFilterInputs.scenario1.selectedObject.country : firstLoadCountry.tid;
    },
    updateBenefitFirstLoad () {
      const countryList = _.cloneDeep(this.getCountries);
      // console.log(this.topbarFilterInputs.scenario1.selectedObject);
      // Add benefit currency, benefit_ppp
      const countryNameAObj = countryList.find(c => c.tid === this.topbarFilterInputs.scenario1.selectedObject.country);
      this.topbarFilterInputs.scenario1.selectedObject.scheme_details.map(async d => {
        const benefitCurrencyObj = await this.getBenefitCurrencyObj(countryNameAObj.name, d.benefit_percent, d.scheme, d.week);
        d.benefit_currency = this.getRoundNumber(benefitCurrencyObj.local_currency, 1);
        d.benefit_ppp = benefitCurrencyObj.ppp_equivalent;
        return d;
      });
    },
    getRoundNumber (num, precision) {
      return Number(Math.round(num + 'e+' + precision) + 'e-' + precision);
    },
    getBenefitCurrencyObj: async function (countryName, percentage, schemeId, maternityWeek) {
      const benefitCurrencyTemp = await this.getBenefitCurrencyData({ countryName, percentage, schemeId, maternityWeek });
      const benefitCurrency = JSON.parse(benefitCurrencyTemp[0]);
      return benefitCurrency;
    },
    getBenefitPercentageObj: async function (countryName, currencyAmount, schemeId, maternityWeek) {
      const benefitPercentageTemp = await this.getBenefitPercentageData({ countryName, currencyAmount, schemeId, maternityWeek });
      const benefitPercentage = JSON.parse(benefitPercentageTemp[0]);
      return benefitPercentage;
    },
    async setDropdownItemFromTaxonomies () {
      // Set country
      const countryList = _.cloneDeep(this.getSp2lnobCountries);
      // const mappedCountry = _.map(countryList, (d) => {
      //   return {
      //     label: d.name,
      //     value: d.id
      //   };
      // });
      // console.log(countryList);
      // console.log(this.topbarFilterInputs.scenario1.selectedObject);
      // this.topbarFilterInputs.scenario1.countryFilters[0].items = mappedCountry;
      for (const c of countryList) {
        if ('detailScenario1' in this.getSp2lnobConfigs && c.code.toLowerCase() in this.getSp2lnobConfigs.detailScenario1.outcome_variables) {
          this.outcomeVariablesByCountries[c.code.toLowerCase()] = this.getSp2lnobConfigs.detailScenario1.outcome_variables[c.code.toLowerCase()];
        } else {
          const indicators = await this.getSp2lnobIndicatorsByCountry(c.code);
          this.outcomeVariablesByCountries[c.code.toLowerCase()] = indicators.sort((a, b) => a.name.localeCompare(b.name));
        }
      }
      let country_code = countryList[0].code;
      if ('country_obj' in this.topbarFilterInputs.scenario1.selectedObject && this.topbarFilterInputs.scenario1.selectedObject.country_obj.field_code) {
        country_code = this.topbarFilterInputs.scenario1.selectedObject.country_obj.field_code;
      }
      // console.log(this.outcomeVariablesByCountries);
      this.outcomeVariables = this.outcomeVariablesByCountries[country_code.toLowerCase()];
      const mappedIndicators = _.map(this.outcomeVariables, (d) => {
        return {
          label: d.name,
          value: d.id
        };
      });
      if (this.outcomeVariables.find(ind => ind.id === this.topbarFilterInputs.scenario1.selectedObject.outcome_variable)) {
        this.outcomeVariableDescription = this.outcomeVariables.find(ind => ind.id === this.topbarFilterInputs.scenario1.selectedObject.outcome_variable).description;
      } else {
        this.topbarFilterInputs.scenario1.selectedObject.outcome_variable = 'clean_fuel';
        this.outcomeVariableDescription = this.outcomeVariables.find(ind => ind.id === 'clean_fuel').description;
      }
      this.topbarFilterInputs.scenario1.outcomeFilters[0].items = mappedIndicators;
    },
    getArticleBenefitLevel (text) {
      let fullText = '';
      const vowelRegex = '^[aieouAIEOU].*';
      if (text.match(vowelRegex)) {
        fullText = `an <strong>${text}</strong>`;
      } else {
        fullText = `a <strong>${text}</strong>`;
      }
      return fullText;
    },
    getSchemeText (arr) {
      const schemeText = arr.length > 1 ? 'schemes' : 'scheme';
      // console.log('getSchemeText');
      // console.log(arr);
      const scheme_text_order = ['70001', '70002', '70003'];
      arr.sort((x, y) => scheme_text_order.indexOf(x) - scheme_text_order.indexOf(y));
      const scheme_items = [
        { value: '70001', label: 'Child' },
        { value: '70002', label: 'Disability' },
        { value: '70003', label: 'Old Age' }
      ];
      const schemesLabels = arr.map(d => scheme_items.find(d2 => d2.value === d).label);
      let schemesLabelText = schemesLabels.join(', ');
      if (arr.length > 1) {
        const last = schemesLabels.pop();
        schemesLabelText = schemesLabels.join(', ') + ' and ' + last;
      }

      return `<strong>${schemesLabelText}</strong> ${schemeText}`;
    },
    getPopoverGlossary: function (insight) {
      const titlePopoverData = [];
      let result = insight;
      let tempResult = insight;
      for (const gs of titlePopoverData) {
        if (!['100038'].includes(gs.tid)) {
          const re = new RegExp(`(${gs.name})(?!([^<]+)?>)`, 'gi');
          const matches = _.uniq(insight.match(re));
          for (const match of matches) {
            tempResult = tempResult.replaceAll(match, `[[${match}]]`);
          }
        }
      }
      result = tempResult;
      for (const gs of titlePopoverData) {
        const re = new RegExp(`(\\[\\[${gs.name}\\]\\])(?!([^<]+)?>)`, 'gi');
        const matches = _.uniq(tempResult.match(re));
        if (matches) {
          for (const match of matches) {
            let matchText = match.replace('[[', '');
            matchText = matchText.replace(']]', '');
            result = result.replaceAll(match, `
              <span
                class="tooltip_text"
                data-bs-toggle="popover"
                data-bs-placement="bottom"
                data-bs-trigger="hover focus"
                title="${gs.name}"
                data-bs-content="${gs.field_definition}">
                ${matchText}
              </span>`);
          }
        }
      }
      return result;
    },
    async getDetailTitle (obj) {
      const sc1Data = {};
      const childObj1 = obj.detailScenario1.scheme_details.filter(s => s.scheme === '70001')[0];
      const disObj1 = obj.detailScenario1.scheme_details.filter(s => s.scheme === '70002')[0];
      const oldObj1 = obj.detailScenario1.scheme_details.filter(s => s.scheme === '70003')[0];
      const formatObj1 = {
        child: childObj1,
        disability: disObj1,
        old_age: oldObj1
      };

      const schemes = ['child', 'disability', 'old_age'];
      const vals = ['benefit_percent', 'age', 'pmt', 'admin_cost', 'is_selected'];

      for (const s of schemes) {
        for (const v of vals) {
          if (v === 'age') {
            sc1Data[`${s}_${v}`] = formatObj1[s][v].join('-');
          } else {
            sc1Data[`${s}_${v}`] = formatObj1[s][v];
          }
        }
      }

      // console.log('sc1Data', sc1Data);

      // Scenario 1 country
      const sc1CountryArr = this.topbarFilterInputs.scenario1.countryFilters[0].items.filter(d => d.value === obj.detailScenario1.country);
      sc1Data.country = sc1CountryArr.length > 0 && sc1CountryArr[0].label ? sc1CountryArr[0].label : obj.detailScenario1.country;

      // Title text Phase 3
      const titleTemplatePhase3 = 'In <strong>[[country]]</strong>, introducing [[schemesText]] at selected benefit levels would:';
      const schemeArrS1 = obj.detailScenario1.scheme_details.filter(d => d.is_selected).map(d => d.scheme).sort();
      // console.log(schemeArrS1);
      sc1Data.schemesText = this.getSchemeText(schemeArrS1);

      sc1Data.title = await getTextFromTemplate(titleTemplatePhase3, sc1Data);

      this.title.scenario1_detail_obj = sc1Data;
    },
    setSidebarSelection () {
      const scenario1DetailConfig = _.cloneDeep(this.topbarFilterInputs.scenario1.selectedObject);
      // console.log(this.outcomeVariables);
      // console.log(this.getSp2lnobConfigs.detailScenario1.outcome_variable);
      // console.log(this.topbarFilterInputs.scenario1.selectedObject);
      if (this.outcomeVariables.length > 0) {
        if (this.outcomeVariables.find(ov => ov.id === this.getSp2lnobConfigs.detailScenario1.outcome_variable)) {
          this.outcomeVariableDescription = this.outcomeVariables.find(ov => ov.id === this.getSp2lnobConfigs.detailScenario1.outcome_variable).description;
          scenario1DetailConfig.outcome_variable_obj = this.outcomeVariables.find(ov => ov.id === this.getSp2lnobConfigs.detailScenario1.outcome_variable);
        } else {
          this.outcomeVariableDescription = this.outcomeVariables.find(ov => ov.id === 'clean_fuel').description;
          scenario1DetailConfig.outcome_variable = 'clean_fuel';
          this.topbarFilterInputs.scenario1.selectedObject.outcome_variable = 'clean_fuel';
          scenario1DetailConfig.outcome_variable_obj = this.outcomeVariables.find(ov => ov.id === 'clean_fuel');
        }
        scenario1DetailConfig.outcome_variables = this.outcomeVariablesByCountries;
      }
      const updateObj = {
        mode: this.mode,
        detailScenario1: scenario1DetailConfig,
        activeTab: this.getSp2lnobConfigs.activeTab ? this.getSp2lnobConfigs.activeTab : 0
      };
      this.getDetailTitle(updateObj);
      // console.log(updateObj);
      // console.log(this.getSp2lnobConfigs);
      this.updateSp2lnobConfigs({
        ...this.getSp2lnobConfigs,
        ...updateObj
      });
      this.setDropdownItemFromTaxonomies();
      this.maintainSelection();
      this.updateToolbarText();
    },
    maintainSelection () {
      const scenario1DetailConfig = _.cloneDeep(this.topbarFilterInputs.scenario1.selectedObject);

      if (this.toolbarType === 'detail') {
        // Set country
        const s1DCountry = scenario1DetailConfig.country;
        // console.log(this.getSp2lnobConfigs.detailScenario1);
        // console.log(s1DCountry);
        // if ('detailScenario1' in this.getSp2lnobConfigs && this.getSp2lnobConfigs.detailScenario1.country !== s1DCountry) {
        //   this.topbarFilterInputs.scenario1.selectedObject.outcome_variable = 'clean_fuel';
        // }
        this.topbarFilterInputs.scenario1.selectedObject.country = s1DCountry;
      }
    },
    changeToolbarType (type) {
      this.updateDashboardToolbarType(type);
      this.setSidebarSelection();
    },
    updateToolbarText () {
      if (this.mode === 'combined') {
        if (this.toolbarType === 'detail') {
          this.topbarFilterInputs.scenario1.countryFilters[0].label = 'Select country:';
        }
      }
    }
  },
  setup () {
    return {
    };
  }
};
</script>

<style lang="scss">
.dashboard-sidebar-container {
  font-size: 12px;
}
.form-label {
  margin-bottom: 0 !important;
}
.filter-container {
  text-align: left;
  width: 25%;
}
.vs__dropdown-menu {
  z-index: 9999 !important;
}
.v-select ul {
  padding: 0 !important;
  width: auto;
  min-width: 100%;
}
.v-select {
  background: white;
  // font-size: 10px;
}
.v-select input {
  position: absolute;
}
.vs__dropdown-toggle {
  cursor: pointer !important;
  // white-space: nowrap !important;
  overflow: hidden !important;
}

#vs2__combobox.vs__dropdown-toggle {
  width: 260px;
}

.close-btn, .add-btn {
  background: transparent;
  &:hover {
    i {
      color: #000000 !important;
    }
  }
}

.title-text {
  font-size: 160%;
}

// Popover
.popover {
  border-radius: 0;
  max-width: 1000px !important;
  width: 700px;
  .popover-header {
    background: #EEF0F6;
  }
}

// detail
.detail-toolbar {
  min-height: 65px;
}
.toolbar-table-container {
  max-width: 100%;
  // overflow: scroll;
}
.table-header {
  font-size: 0.7rem;
}
.table-header-sm {
  font-size: 0.5rem;
}
.table-content {
  font-size: 0.8rem;
}
.table-content-sm {
  font-size: 0.5rem;
}

@media (max-width: 575px) {
  .selection-container {
    width: 50% !important;
  }
  // .dashboard-sidebar-container {
  //   font-size: 7px !important;
  // }
}

.custom-tooltip:hover .tooltiptext {
  visibility: visible;
}

.custom-tooltip .tooltiptext {
  visibility: hidden;
  width: 220px;
  background-color: white;
  color: darkgrey;
  padding: 5px 5px;
  border-radius: 6px;
  font-size: 13px;
  border: 1px solid darkgrey;
  position: absolute;
  z-index: 1;
  bottom: 75%;
  left: -100%;
  margin-left: -60px;
  text-align: left;
}

.custom-tooltip {
  position: relative;
  display: inline-block;
}

.variable-des {
  width: 95%;
  padding-left: 200px;
  padding-top: 0px;
  padding-bottom: 0.25rem;
}

.sp2lnob-dashboard-app .dashboard-sidebar-container {
  top: 45px;
  padding-top: 10px;
  left: auto;
  right: 0;
  position: sticky;
  z-index: 199;
  background-color: white;
}

.page__sp2lnob_dashboard-app .modal-backdrop.fade.show {
  display: none;
}

.sp2lnob-dashboard-app #modalSlider {
  top: 55px !important;
}
</style>
